import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/authStore';

/**
 * Private layout — requires a valid auth token.
 * Redirects to /login if not authenticated, preserving the intended destination.
 */
export function PrivateLayout() {
  const auth = useAuth();
  const location = useLocation();
  if (!auth?.token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}
